import { Dialog } from '@sravni/react-design-system/lib/Dialog';
import { Sheet } from '@sravni/react-design-system/lib/Sheet';
import { useIsPhone } from '@sravni/react-utils';

import { BonusInfoContent } from '../BonusInfoContent';

import styles from './BonusInfo.module.scss';

export type BonusInfoProps = {
  visible: boolean;
  onClose: () => void;
};

export const BonusInfo = (props: BonusInfoProps) => {
  const { visible, onClose } = props;

  const isPhone = useIsPhone();

  if (isPhone) {
    return (
      <Sheet visible={visible} onClose={onClose}>
        <Sheet.Header title="Подробнее о бонусах Сравни" />
        <Sheet.Content>
          <BonusInfoContent onClose={onClose} />
        </Sheet.Content>
      </Sheet>
    );
  }

  return (
    <Dialog visible={visible} onClose={onClose} className={styles.dialog} closable={false}>
      <Dialog.Header title="Подробнее о&nbsp;бонусах Сравни" />
      <Dialog.Content>
        <BonusInfoContent onClose={onClose} />
      </Dialog.Content>
    </Dialog>
  );
};
